import React, { useState, useEffect } from "react";
import "../App.css";
import { useHistory, useLocation } from "react-router-dom";
import { Button } from "reactstrap";
import MyStorage from "./util/storage";
import Api from "./api/api";
import MyLoader from "./util/loader";
import { ToastContainer } from "react-toastify";

const UserAdminAssignments = ({ routes }) => {
  const history = useHistory();
  const location = useLocation();
  const user = location.state.user;

  const [models, setModels] = useState([]);
  const [loader, setLoader] = useState(false);

  // load data
  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    Api.getAdminAssignments(
      user.id,
      (response) => {
        // console.log(JSON.stringify(response.data[0]));
        setLoader(false);
        setModels(response.data);
        for (let i = 0; i < response.data.length; i++) {
          const item = {
            cat_id: response.data[i].cat_id,
            video_id: response.data[i].video_id,
            special_program: response.data[i].special_program,
            video: response.data[i].video,
          };
          console.log("item: " + JSON.stringify(item));
        }
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const removeAssignment = (model) => {
    if (window.confirm("Remove access to this assigned item?")) {
      setLoader(true);
      Api.removeMembers(
        model.id,
        (response) => {
          setLoader(false);
          loadData();
        },
        (error) => {
          setLoader(false);
        }
      );
    }
  };

  const getProfilePhoto = (model) => {
    if (
      MyStorage.getFileUrls() == null ||
      model.photo == null ||
      model.photo === ""
    ) {
      return user;
    } else {
      if (model.photo.includes("http")) {
        return model.photo;
      }
      return MyStorage.getFileUrls().User + model.photo;
    }
  };

  const showVideos = (video) => {
    return (
      <div style={{ marginTop: 0, display: "flex", width: "100%" }}>
        <div className="projects-item-photo">
          <img
            src={video.thumbnail}
            style={{
              padding: 1,
              width: 70,
              height: 70,
              objectFit: "cover",
            }}
          />
        </div>
        <div
          className="projects-item-cat"
          style={{
            flex: 1,
            display: "flex",
            alignSelf: "center",
            flexDirection: "column",
          }}
        >
          <div style={{ fontSize: 16 }}>VideoID: {video.id}</div>
          <div style={{ fontSize: 16 }}>{video.title}</div>
        </div>
      </div>
    );
  };

  const showCats = (model) => {
    return (
      <div style={{ marginTop: 0, display: "flex", width: "100%" }}>
        <div className="projects-item-photo">
          <img
            src={model.special_program.image}
            style={{
              padding: 1,
              width: 70,
              height: 70,
              objectFit: "cover",
            }}
          />
        </div>
        <div
          className="projects-item-cat"
          style={{
            flex: 1,
            display: "flex",
            alignSelf: "center",
            flexDirection: "column",
          }}
        >
          <div style={{ fontSize: 16 }}>CatID: {model.special_program.id}</div>
          <div style={{ fontSize: 16 }}>{model.special_program.title}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="main">
      <div
        className="titlebar"
        style={{ backgroundColor: "#f2f2f2", padding: 10, margin: -15 }}
      >
        <div style={{ color: "blue" }}>
          "{user.fname + " " + user.lname}" has Joined these items (includes
          admin assignments)
        </div>
      </div>

      <div style={{ width: "100%", marginTop: 30 }}>
        {models.map((model, index) => {
          if (model.video == null && model.special_program == null) {
            return null;
          }
          let className =
            index % 2 !== 0 ? "projects-itembar" : "projects-itembar-colored";
          return (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div className={className} style={{ marginTop: 0 }}>
                <div className="projects-item-cat" style={{}}>
                  {model.cat_id + "" === "" || model.cat_id + "" === "0"
                    ? showVideos(model.video)
                    : showCats(model)}
                </div>

                <div
                  className="projects-item-cat"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <Button
                    className="btn-block btn-submit"
                    style={{ width: 150, fontSize: 16 }}
                    onClick={() => {
                      console.log("type: " + model.type);
                      if (model.special_program != null) {
                        localStorage.setItem(
                          "libraryselectedCat",
                          JSON.stringify(model.special_program)
                        );
                        localStorage.setItem(
                          "specialparentCat",
                          JSON.stringify(model.special_program)
                        );
                        if (model.type === "library") {
                          history.push("/library");
                        } else {
                          history.push("/special-library");
                        }
                      } else if (model.video != null) {
                        // video
                        history.push({
                          pathname: "/play-video",
                          state: { model: model.video },
                        });
                      }
                    }}
                  >
                    View
                  </Button>
                  <Button
                    className="btn-block btn-submit"
                    style={{
                      marginLeft: 10,
                      width: 150,
                      fontSize: 16,
                      backgroundColor: "red",
                    }}
                    onClick={() => {
                      removeAssignment(model);
                    }}
                  >
                    Remove
                  </Button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <MyLoader loader={loader} />

      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default UserAdminAssignments;
